import './css/estudiantes.css';

function Trayecto({ cursos }) {
  // Orden deseado
  const ordenDeseado = ["s2", "s3", "s4", "s5", "1", "2", "3", "4", "5", "6"];

  // Ordenamos cursos
  const cursosOrdenados = [...cursos].sort((a, b) => {
    const indexA = ordenDeseado.indexOf(a.orden.toString().toLowerCase());
    const indexB = ordenDeseado.indexOf(b.orden.toString().toLowerCase());
    return (indexA === -1 ? 999 : indexA) - (indexB === -1 ? 999 : indexB);
  });

  // Nos quedamos solo con combinaciones únicas de cohorte+orden+denominacion
  const gruposUnicos = [];
  cursosOrdenados.forEach(curso => {
    const clave = `${curso.cohorte}-${curso.orden}-${curso.denominacion}`;
    if (!gruposUnicos.find(g => g.clave === clave)) {
      gruposUnicos.push({ 
        clave, 
        cohorte: curso.cohorte, 
        orden: curso.orden, 
        denominacion: curso.denominacion, 
        nombre_espacio: curso.nombre_espacio 
      });
    }
  });

  // Traducción del nombre según el orden
  const mostrarNombre = (orden) => {
    switch (orden.toUpperCase()) {
      case "S2": return "Sala 2 años";
      case "S3": return "Sala 3 años";
      case "S4": return "Sala 4 años";
      case "S5": return "Sala 5 años";
      case "IN": return "Espacio Institucional";
      default: return `${orden}°`;
    }
  };

  return (
    <div>
      <div className='card shadow border-0 bg-secondary-subtle m-1 p-2'>
        <h6>
          Trayectoria académica ...{" "}
          <i className="text-success fa-solid fa-person-running"></i>
        </h6>
      </div>

      <ul className='cursos m-1'>
        {gruposUnicos.map((grupo, i) => (
          <li key={i}>
            <div>
              <strong>{grupo.cohorte}</strong>
            </div>
            <div className="text-muted small">
                {mostrarNombre(grupo.orden)} 
                {grupo.orden.toUpperCase().startsWith("S")?
                    <> "{grupo.denominacion}"</>
                :
                    <> "{grupo.denominacion}"</>
                }
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default Trayecto;
